var _path, _path2, _path3, _line, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 24,
    viewBox: "0 0 102 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3667 16.1086L4.3039 6.42H0.5597V4.49H6.5813V6.3814L2.6441 16.07H6.5813V18H0.3667V16.1086ZM10.7946 4.49H17.7619V6.42H14.0949V9.9905H17.0092V11.9205H14.0949V16.07H17.7619V18H11.9719V15.3559H9.88748L9.21198 18H7.18548L10.7946 4.49ZM11.9719 13.5224V7.0955H11.9333L10.3507 13.5224H11.9719ZM18.9793 4.49H21.6427L23.7078 12.5767H23.7464V4.49H25.6378V18H23.4569L20.9093 8.1377H20.8707V18H18.9793V4.49ZM27.2157 4.49H29.3387V18H27.2157V4.49ZM32.5885 6.42H30.369V4.49H36.931V6.42H34.7115V18H32.5885V6.42ZM37.9589 4.49H40.0819V9.9905H42.3593V4.49H44.4823V18H42.3593V11.9205H40.0819V18H37.9589V4.49Z",
    fill: "url(#paint0_linear_9_168)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5616 4.49H47.6074L48.5531 14.8734H48.5917L49.5953 4.49H51.9113L52.9149 14.8734H52.9535L53.8992 4.49H55.7327L54.3624 18H51.7183L50.7533 8.8904H50.7147L49.7497 18H46.9319L45.5616 4.49ZM56.8065 4.49H62.5965V6.42H58.9295V9.9905H61.8438V11.9205H58.9295V16.07H62.5965V18H56.8065V4.49ZM63.8179 4.49H67.0217C68.1153 4.49 68.9131 4.74733 69.4149 5.262C69.9167 5.7638 70.1676 6.54223 70.1676 7.5973V8.1377C70.1676 8.8325 70.0518 9.39863 69.8202 9.8361C69.6014 10.2736 69.2605 10.5888 68.7973 10.7818V10.8204C69.8523 11.1807 70.3799 12.1199 70.3799 13.6382V14.7962C70.3799 15.8384 70.1032 16.6361 69.55 17.1894C69.0096 17.7298 68.2118 18 67.1568 18H63.8179V4.49ZM66.7708 9.9905C67.1954 9.9905 67.5106 9.88113 67.7165 9.6624C67.9352 9.44367 68.0446 9.07697 68.0446 8.5623V7.8096C68.0446 7.32067 67.9545 6.96683 67.7744 6.7481C67.6071 6.52937 67.3369 6.42 66.9638 6.42H65.9409V9.9905H66.7708ZM67.1568 16.07C67.5299 16.07 67.8065 15.9735 67.9867 15.7805C68.1668 15.5746 68.2569 15.2272 68.2569 14.7383V13.561C68.2569 12.9434 68.1475 12.5188 67.9288 12.2872C67.7229 12.0427 67.3755 11.9205 66.8866 11.9205H65.9409V16.07H67.1568Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 13C88.4673 13 91.5327 13 97 13",
    stroke: "url(#paint1_linear_9_168)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 7.5,
    x2: 94,
    y2: 7.5,
    stroke: "url(#paint2_linear_9_168)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4737 17.5L90 1L99.5263 17.5H80.4737Z",
    stroke: "url(#paint3_linear_9_168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_168",
    x1: -0.00000106693,
    y1: 7.34483,
    x2: 43.7886,
    y2: 13.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17F88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_168",
    x1: 83,
    y1: 11.5,
    x2: 96.4167,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17F88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_168",
    x1: 86,
    y1: 7.5,
    x2: 93.6667,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17F88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_168",
    x1: 85.5,
    y1: 8,
    x2: 100.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17F88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17F8F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.5afb96baf51f4a679fc8995ccde8ff4d.svg";
export { ForwardRef as ReactComponent };